import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ArtistRow from '@/components/common/ArtistRow.vue';
import DiscountList from './DiscountList.vue';
import SaleLabelList from './SaleLabel-list.vue';
import LazyImage from './LazyImage.vue';
import DiscountTag from './DiscountTag.vue';
import GroupInfo from './GroupInfo.vue';
import Drip from 'drip';
import Star from 'comp/star/Star';
import { getStar } from '@/utils/getStar';
import { parseDetailUrl } from '@/utils';
export default {
  name: 'detail-entrance-new',
  props: ['show', 'index', 'bid', 'viewBid', 'isCalendarPage', 'isBrandPage', 'showTopInfo', 'isSearch'],
  components: {
    ArtistRow: ArtistRow,
    SaleLabelList: SaleLabelList,
    LazyImage: LazyImage,
    DiscountList: DiscountList,
    Star: Star,
    DiscountTag: DiscountTag,
    GroupInfo: GroupInfo
  },
  mounted: function mounted() {
    this.getPrice();
  },
  data: function data() {
    var _Drip$constant;
    return {
      computePrice: '',
      priceSuffix: '',
      cityId: Drip === null || Drip === void 0 ? void 0 : (_Drip$constant = Drip.constant) === null || _Drip$constant === void 0 ? void 0 : _Drip$constant.cityId,
      showGroup: true
    };
  },
  watch: {
    'show.priceRange': {
      handler: function handler(val, old) {
        var _this = this;
        this.computePrice = '';
        this.$nextTick(function () {
          _this.getPrice();
        });
      },
      deep: true
    }
  },
  computed: {
    discountImg: function discountImg() {
      var _this$show, _this$show2, _this$show2$couponAct;
      var listActivityTagUrl = this.show && ((_this$show = this.show) === null || _this$show === void 0 ? void 0 : _this$show.couponActivityTagVO) && ((_this$show2 = this.show) === null || _this$show2 === void 0 ? void 0 : (_this$show2$couponAct = _this$show2.couponActivityTagVO) === null || _this$show2$couponAct === void 0 ? void 0 : _this$show2$couponAct.listActivityTagUrl);
      return listActivityTagUrl || '';
    },
    showGeneralAgentIcon: function showGeneralAgentIcon() {
      if (!this.show) return false;
      var _this$show3 = this.show,
        exclusive = _this$show3.exclusive,
        generalAgent = _this$show3.generalAgent;
      if (generalAgent && !exclusive) {
        return true;
      }
      return false;
    },
    showExclusiveAgentIcon: function showExclusiveAgentIcon() {
      var _this$show4;
      return this.show && !!((_this$show4 = this.show) !== null && _this$show4 !== void 0 && _this$show4.exclusive);
    },
    showOwnerTag: function showOwnerTag() {
      var _this$show5, _this$show6, _this$show6$performan;
      return ((_this$show5 = this.show) === null || _this$show5 === void 0 ? void 0 : _this$show5.exclusive) && [1, 2, 3, 11].includes((_this$show6 = this.show) === null || _this$show6 === void 0 ? void 0 : (_this$show6$performan = _this$show6.performanceLabelVO) === null || _this$show6$performan === void 0 ? void 0 : _this$show6$performan.saleLabel);
    },
    showXZGP: function showXZGP() {
      var _this$show7, _this$show8, _this$show9, _this$show10, _this$show10$performa;
      return !((_this$show7 = this.show) !== null && _this$show7 !== void 0 && _this$show7.unusualSaleStatus) && !!(this !== null && this !== void 0 && (_this$show8 = this.show) !== null && _this$show8 !== void 0 && _this$show8.seatType) && ((_this$show9 = this.show) === null || _this$show9 === void 0 ? void 0 : _this$show9.seatType) !== 0 && [2, 3].includes((_this$show10 = this.show) === null || _this$show10 === void 0 ? void 0 : (_this$show10$performa = _this$show10.performanceLabelVO) === null || _this$show10$performa === void 0 ? void 0 : _this$show10$performa.saleLabel);
    },
    // 是否展示销售状态标签
    showSaleLabel: function showSaleLabel() {
      var _this$show11;
      return ((_this$show11 = this.show) === null || _this$show11 === void 0 ? void 0 : _this$show11.categoryId) !== 14;
    },
    showPrice: function showPrice() {
      var _this$show12, _this$show12$performa;
      return ((_this$show12 = this.show) === null || _this$show12 === void 0 ? void 0 : (_this$show12$performa = _this$show12.performanceLabelVO) === null || _this$show12$performa === void 0 ? void 0 : _this$show12$performa.saleLabel) !== 5;
    },
    showSelf: function showSelf() {
      var _this$show13, _this$show14, _this$show14$performa;
      return ((_this$show13 = this.show) === null || _this$show13 === void 0 ? void 0 : _this$show13.self) && ((_this$show14 = this.show) === null || _this$show14 === void 0 ? void 0 : (_this$show14$performa = _this$show14.performanceLabelVO) === null || _this$show14$performa === void 0 ? void 0 : _this$show14$performa.saleLabel) !== 5;
    },
    showOtherChannel: function showOtherChannel() {
      var _this$show15, _this$show16, _this$show17, _this$show17$performa;
      return !((_this$show15 = this.show) !== null && _this$show15 !== void 0 && _this$show15.self) && ((_this$show16 = this.show) === null || _this$show16 === void 0 ? void 0 : _this$show16.thirdPartyDesc) && ((_this$show17 = this.show) === null || _this$show17 === void 0 ? void 0 : (_this$show17$performa = _this$show17.performanceLabelVO) === null || _this$show17$performa === void 0 ? void 0 : _this$show17$performa.saleLabel) !== 5;
    },
    showDiscountInfo: function showDiscountInfo() {
      var _this$show18, _this$show18$performa, _this$show19, _this$show20, _this$show20$promotio;
      var priceRangeType = this.show && this.show.priceRangeType;
      var hasPromotionVoPrice = this.show && this.show.promotionVO && this.show.promotionVO.minSellPrice;
      var showDiscountSaleLabel = [];
      if (priceRangeType != 1 || hasPromotionVoPrice) {
        showDiscountSaleLabel = [1, 11, 2, 3];
      } else {
        showDiscountSaleLabel = [2, 3];
      }
      return showDiscountSaleLabel.includes((_this$show18 = this.show) === null || _this$show18 === void 0 ? void 0 : (_this$show18$performa = _this$show18.performanceLabelVO) === null || _this$show18$performa === void 0 ? void 0 : _this$show18$performa.saleLabel) || ((_this$show19 = this.show) === null || _this$show19 === void 0 ? void 0 : _this$show19.promotional) && ((_this$show20 = this.show) === null || _this$show20 === void 0 ? void 0 : (_this$show20$promotio = _this$show20.promotional) === null || _this$show20$promotio === void 0 ? void 0 : _this$show20$promotio.supportWenhui);
    },
    showSeeLabel: function showSeeLabel() {
      var _this$show21, _this$show22, _this$show22$relieved;
      return ((_this$show21 = this.show) === null || _this$show21 === void 0 ? void 0 : _this$show21.relievedTagVO) && ((_this$show22 = this.show) === null || _this$show22 === void 0 ? void 0 : (_this$show22$relieved = _this$show22.relievedTagVO) === null || _this$show22$relieved === void 0 ? void 0 : _this$show22$relieved.isRelieved) === 0;
    },
    // 是否是游戏剧场项目
    isGameProject: function isGameProject() {
      var _this$show23;
      return ((_this$show23 = this.show) === null || _this$show23 === void 0 ? void 0 : _this$show23.categoryId) === 14;
    },
    // 是否是拼场售卖
    isShowPoolSale: function isShowPoolSale() {
      var _this$show24;
      //  1-拼场，2-单独售卖
      return ((_this$show24 = this.show) === null || _this$show24 === void 0 ? void 0 : _this$show24.saleType) === 1;
    },
    // 品牌馆列表，无座项目不展示在售中标签
    isHideSaleTag: function isHideSaleTag() {
      var _this$show25, _this$show26, _this$show26$performa;
      return !(((_this$show25 = this.show) === null || _this$show25 === void 0 ? void 0 : _this$show25.seatType) === 0 && ((_this$show26 = this.show) === null || _this$show26 === void 0 ? void 0 : (_this$show26$performa = _this$show26.performanceLabelVO) === null || _this$show26$performa === void 0 ? void 0 : _this$show26$performa.saleLabel) === 3 && this.isBrandPage);
    },
    isGroupInfoHasMarginTop: function isGroupInfoHasMarginTop() {
      return !(this.showDiscountInfo && !this.isBrandPage);
    }
  },
  methods: {
    getStarNum: getStar,
    to: function to(e) {
      try {
        var target = e.currentTarget;
        var _target$dataset = target.dataset,
          performanceid = _target$dataset.performanceid,
          itemindex = _target$dataset.itemindex,
          _target$dataset$jumpd = _target$dataset.jumpdetailurl,
          jumpdetailurl = _target$dataset$jumpd === void 0 ? '' : _target$dataset$jumpd,
          _target$dataset$categ = _target$dataset.categoryid,
          categoryid = _target$dataset$categ === void 0 ? '' : _target$dataset$categ;
        this.$emit('clickStatus', {
          // performance_id: performanceid,
          categoryid: categoryid,
          index: itemindex,
          performanceid: performanceid,
          itemindex: itemindex
        });
        if (jumpdetailurl) {
          Drip.redirect("/myshow/#".concat(parseDetailUrl(jumpdetailurl)));
        } else {
          var _this$show27;
          Drip.redirect("/myshow/#/detail/".concat((_this$show27 = this.show) === null || _this$show27 === void 0 ? void 0 : _this$show27.performanceId));
        }
      } catch (e) {}
    },
    getPrice: function getPrice() {
      var _this$$refs, _this$show28;
      var detailDom = (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs.detail;
      if (detailDom && detailDom.offsetWidth && ((_this$show28 = this.show) === null || _this$show28 === void 0 ? void 0 : _this$show28.priceRange) !== '价格待定') {
        var _Array$prototype, _Array$prototype$redu;
        var tips = detailDom.querySelectorAll('.i-tips-compute');
        var tipsWidth = (_Array$prototype = Array.prototype) === null || _Array$prototype === void 0 ? void 0 : (_Array$prototype$redu = _Array$prototype.reduce) === null || _Array$prototype$redu === void 0 ? void 0 : _Array$prototype$redu.call(tips, function (t, c) {
          return t + c.offsetWidth;
        }, 12);
        if (detailDom.offsetWidth <= tipsWidth) {
          var _this$show29, _this$show29$priceRan;
          this.computePrice = (_this$show29 = this.show) === null || _this$show29 === void 0 ? void 0 : (_this$show29$priceRan = _this$show29.priceRange) === null || _this$show29$priceRan === void 0 ? void 0 : _this$show29$priceRan.split('-')[0];
          this.priceSuffix = '起';
        } else if (!this.priceSuffix) {
          var _this$show30;
          this.computePrice = (_this$show30 = this.show) === null || _this$show30 === void 0 ? void 0 : _this$show30.priceRange;
          this.priceSuffix = '';
        }
      }
    },
    initPrice: function initPrice(priceRange) {
      if (priceRange && priceRange !== '价格待定') {
        var priceArr = priceRange.split('-');
        if (priceArr.length > 1) {
          return [priceArr[0], '起'];
        } else if (priceArr.length === 1) {
          return [priceArr[0], ''];
        } else {
          return ['', ''];
        }
      }
      return ['', ''];
    },
    onGroupCountDownFinish: function onGroupCountDownFinish() {
      this.showGroup = false;
    }
  }
};